// Vue
import { Component } from "vue-property-decorator";
// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
  },
})
export class ContentHighlightModule extends ModuleBase {
  private openStatus: boolean[] = [];

  private isDragging = false;
  private dragStartDividerPosition = 50;
  private dragStartPixelPosition = 0;
  private dragElementWidth = 0;
  public dividerPosition = 50;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get getColorClass() {
    let color = this.instance["section_text"]["color"];
    return color == "white" ? "white" : "black";
  }

  public openPopup(index) {
    let openStatus: boolean[] = [];

    this.instance["highlights"].forEach(() => {
      openStatus.push(false);
    });

    openStatus[index] = true;
    this.openStatus = openStatus;
  }

  public isOpen(index) {
    if (this.openStatus.length > index) {
      return this.openStatus[index];
    } else {
      return false;
    }
  }

  public closePopupElement(index) {
    this.instance["highlights"].forEach(() => {
      this.openStatus.push(false);
    });

    this.openStatus[index] = false;
  }

  mounted() {
    document.addEventListener("touchmove", this.dragMove, { passive: false });
    document.addEventListener("touchend", this.dragEnd, { passive: false });
    document.addEventListener("mousemove", this.dragMove);
    document.addEventListener("mouseup", this.dragEnd);
    document.addEventListener("mouseleave", this.dragEnd);
  }

  beforeDestroy() {
    document.removeEventListener("touchmove", this.dragMove);
    document.removeEventListener("touchend", this.dragEnd);
    document.removeEventListener("mousemove", this.dragMove);
    document.removeEventListener("mouseup", this.dragEnd);
    document.removeEventListener("mouseleave", this.dragEnd);
  }

  dragStart(e: MouseEvent | TouchEvent) {
    this.isDragging = true;
    this.dragStartDividerPosition = this.dividerPosition;
    if (e instanceof MouseEvent) {
      this.dragStartPixelPosition = e.pageX;
    } else if (e instanceof TouchEvent) {
      this.dragStartPixelPosition = e.touches[0].pageX;
    }
    let element: HTMLElement = <HTMLElement>this.$refs["drag-element"];
    this.dragElementWidth = element.offsetWidth;
  }

  dragMove(e: MouseEvent | TouchEvent) {
    if (this.isDragging) {
      e.preventDefault();
      let moveX = 0;
      if (e instanceof MouseEvent) {
        moveX = e.pageX;
      } else if (e instanceof TouchEvent) {
        moveX = e.touches[0].pageX;
      }
      let diffMovement = moveX - this.dragStartPixelPosition;
      let percentMovement =
        (Math.abs(diffMovement) / this.dragElementWidth) * 100;

      let dividerPosition = 0;

      if (diffMovement < 0) {
        dividerPosition = this.dragStartDividerPosition - percentMovement;
      } else {
        dividerPosition = this.dragStartDividerPosition + percentMovement;
      }

      if (dividerPosition < 0) {
        dividerPosition = 0;
      }

      if (dividerPosition > 100) {
        dividerPosition = 100;
      }

      this.dividerPosition = dividerPosition;
    }
  }

  dragEnd() {
    this.isDragging = false;
  }
}
